/**
 * Sticky Learning Coach (robot) visibility helpers.
 * Backend setup API currently only supports student-dashboard.
 */

export const LEARNING_COACH_SETUP_TYPE = 'student-dashboard'

/** Routes where the sticky Learning Coach robot may appear. */
export const LEARNING_COACH_VISIBLE_ROUTES = [
  'student-dashboard',
]

/**
 * Whether the sticky Learning Coach should be hidden for a route.
 * Always respects district/school dashboard_chatbot visibility when the route is allowed.
 *
 * @param {string|null|undefined} routeName
 * @param {(key: string, schoolSettings: unknown, districtSettings: unknown) => boolean} isVisibleFn
 * @param {unknown} schoolSetting
 * @param {unknown} distSetting
 * @returns {boolean}
 */
export function shouldHideLearningCoach(routeName, isVisibleFn, schoolSetting, distSetting) {
  if (!LEARNING_COACH_VISIBLE_ROUTES.includes(routeName)) {
    return true
  }
  return !isVisibleFn('dashboard_chatbot', schoolSetting, distSetting)
}

/**
 * Map a UI route/mode to the Learning Coach setup API type.
 * Unsupported types fall back to student-dashboard to avoid 404s.
 *
 * @param {string|null|undefined} routeOrMode
 * @returns {string}
 */
export function resolveLearningCoachSetupType(routeOrMode) {
  if (routeOrMode === LEARNING_COACH_SETUP_TYPE) {
    return LEARNING_COACH_SETUP_TYPE
  }
  if (LEARNING_COACH_VISIBLE_ROUTES.includes(routeOrMode)) {
    return LEARNING_COACH_SETUP_TYPE
  }
  return LEARNING_COACH_SETUP_TYPE
}

/**
 * Map a UI route to the Learning Coach chat mode (prompt set).
 * Teacher class routes use the dashboard coach prompts.
 *
 * @param {string|null|undefined} routeName
 * @returns {string}
 */
export function resolveLearningCoachMode(routeName) {
  if (routeName === LEARNING_COACH_SETUP_TYPE) {
    return LEARNING_COACH_SETUP_TYPE
  }
  if (LEARNING_COACH_VISIBLE_ROUTES.includes(routeName)) {
    return LEARNING_COACH_SETUP_TYPE
  }
  return routeName || LEARNING_COACH_SETUP_TYPE
}
